import React from "react";
import { SectionLabel, SectionHeading } from "./SectionLabel";
import { FOUNDER_PHOTOS } from "@/config/site";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-[rgba(198,162,99,0.12)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <SectionLabel number="04" label="Meet the Founder" />
          <SectionHeading className="mt-6">
            The studio behind{" "}
            <span className="italic text-gold-metal">Uberti Creative</span>.
          </SectionHeading>

          <p className="mt-8 text-base md:text-lg leading-relaxed text-[rgb(var(--bone-dim))]">
            Founded by{" "}
            <span className="text-[rgb(var(--bone))]">Mason Uberti</span>,
            Uberti Creative was built to help businesses elevate their digital
            presence through content creation, branding, social media strategy,
            and visual storytelling.
          </p>

          <p className="mt-6 text-base md:text-lg leading-relaxed text-[rgb(var(--bone-dim))]">
            The studio combines a background in{" "}
            <span className="text-[rgb(var(--bone))]">
              Media, Information &amp; Technoculture
            </span>{" "}
            from Western University with hands-on experience in content
            creation, social media, and brand presentation.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
            <div className="border-l border-[rgba(198,162,99,0.35)] pl-4">
              <div className="font-cinzel text-[11px] tracking-[0.3em] uppercase text-[rgb(var(--gold-soft))]">
                Based In
              </div>
              <div className="mt-2 text-[rgb(var(--bone))]">Vaughan / GTA</div>
            </div>
            <div className="border-l border-[rgba(198,162,99,0.35)] pl-4">
              <div className="font-cinzel text-[11px] tracking-[0.3em] uppercase text-[rgb(var(--gold-soft))]">
                Founded
              </div>
              <div className="mt-2 text-[rgb(var(--bone))]">2025</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative rounded-2xl overflow-hidden border border-[rgba(198,162,99,0.18)] aspect-[4/5]">
            <img
              src={FOUNDER_PHOTOS.headshot2}
              alt="Mason Uberti — Founder, Uberti Creative"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: "50% 30%" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.78)] via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="text-[11px] tracking-[0.3em] uppercase text-[rgb(var(--gold-soft))]">
                Founder &amp; Creative Director
              </div>
              <div className="mt-1 font-serif-display text-2xl text-[rgb(var(--bone))]">
                Mason Uberti
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
